const getWidth = <T>(arr: { variable: string; label: string; width: number }[]): { width: T; label: T } => {
  let max = 0
  let keys: string[] = []
  arr.forEach((r) => {
    max += r.width
    keys.push(r.variable)
  })
  let width: any = {}
  let label: any = {}
  for (let i = 0; i < arr.length; i++) {
    width = { ...width, [keys[i]]: arr[i].width / max }
    label = { ...label, [keys[i]]: arr[i].label }
  }
  return {
    width: width,
    label: label,
  }
}

/**
 * px指定版
 */
const getWidthPx = <T>(arr: { variable: string; label: string; width: number }[]): { width: T; label: T } => {
  let keys: string[] = []
  arr.forEach((r) => {
    keys.push(r.variable)
  })
  let width: any = {}
  let label: any = {}
  for (let i = 0; i < arr.length; i++) {
    width = { ...width, [keys[i]]: arr[i].width }
    label = { ...label, [keys[i]]: arr[i].label }
  }
  return {
    width: width,
    label: label,
  }
}

/**
 * 商品受領確認表サマリテーブル
 */
export const juryoTable = getWidth<{
  NO: number | string
  CHECK: number | string
  JURYO_KBN: number | string
  DENPYO_NO: number | string
  NOHIN_YMD: number | string
  GYO_NO: number | string
  DENPYO_KBN: number | string
  JAN_CD: number | string
  // SHOHIN_KIKAKU: number | string // 品名と規格を分離 JBCC塩川@20250521
  SHOHIN: number | string
  KIKAKU: number | string
  SURYO: number | string
  NOHIN_SURYO: number | string
  GEN_TANKA: number | string
  BAI_TANKA: number | string
  GENKA: number | string
  BAIKA: number | string
  TOKUI_NM: number | string
  TEN_NM: number | string
  JIGYO_NM: number | string
  NAIYO: number | string
  NAIYO_LONG: number | string
}>([
  { variable: 'NO', label: 'NO', width: 1.5 },
  { variable: 'CHECK', label: 'CHECK', width: 1 },
  { variable: 'JURYO_KBN', label: '受領区分', width: 1 },
  { variable: 'DENPYO_NO', label: '伝票番号', width: 2.1 },
  { variable: 'NOHIN_YMD', label: '伝票日付', width: 1.5 },
  { variable: 'GYO_NO', label: '行', width: 0.5 },
  { variable: 'DENPYO_KBN', label: '伝票区分', width: 1.5 },
  { variable: 'JAN_CD', label: 'JANコード', width: 2.5 },
  // { variable: 'SHOHIN_KIKAKU', label: '品名／規格', width: 3.5 },
  { variable: 'SHOHIN', label: '品名', width: 4.5 },
  { variable: 'KIKAKU', label: '規格', width: 2.5 },
  { variable: 'SURYO', label: '発注数', width: 1.5 },
  { variable: 'NOHIN_SURYO', label: '納品数', width: 1.5 },
  { variable: 'GEN_TANKA', label: '原単価', width: 1.5 },
  { variable: 'BAI_TANKA', label: '売単価', width: 1.5 },
  { variable: 'GENKA', label: '原価金額', width: 1.5 },
  { variable: 'BAIKA', label: '売価金額', width: 1.5 },
  { variable: 'TOKUI_NM', label: '得意先名', width: 3.9 },
  { variable: 'TEN_NM', label: '店舗名', width: 3 },
  { variable: 'JIGYO_NM', label: '事業所名', width: 2 },
  { variable: 'NAIYO', label: '内容確認依頼', width: 2.5 },
  { variable: 'NAIYO_LONG', label: '内容確認依頼', width: 4 },
])

/**
 * 商品受領確認表サマリテーブル
 */
export const juryoMobileSummaryTable = getWidth<{
  JURYO_KBN: number | string
  NOHIN_YMD: number | string
  TOKUI_NM: number | string
  TEN_NM: number | string
}>([
  { variable: 'JURYO_KBN', label: '受領区分', width: 1.6 },
  { variable: 'NOHIN_YMD', label: '伝票日付', width: 1.6 },
  { variable: 'TOKUI_NM', label: '得意先名', width: 2 },
  { variable: 'TEN_NM', label: '店舗名', width: 2 },
])

/**
 * 商品受領確認表明細テーブル
 * !! px指定
 */
export const juryoMobileDetailTable = getWidthPx<{
  JAN_CD: number | string
  // SHOHIN_KIKAKU: number | string // 品名と規格を分離 JBCC塩川@20250521
  SHOHIN: number | string
  KIKAKU: number | string
  SURYO: number | string
  NOHIN_SURYO: number | string
  NAIYO: number | string
  // DENPYO_KBN: number | string // 伝票番号に変更 JBCC塩川@20250521
  DENPYO_NO: number | string
  GEN_TANKA: number | string
  BAI_TANKA: number | string
  GENKA: number | string
  BAIKA: number | string
  JURYO_KBN: number | string
}>([
  { variable: 'JAN_CD', label: 'JAN_CD', width: 105 },
  // { variable: 'SHOHIN_KIKAKU', label: '品名／規格', width: 4 }, // 品名と規格を分離 JBCC塩川@20250521
  { variable: 'SHOHIN', label: '品名', width: 150 },
  { variable: 'KIKAKU', label: '規格', width: 100 },
  { variable: 'SURYO', label: '発注数', width: 60 },
  { variable: 'NOHIN_SURYO', label: '納品数', width: 60 },
  { variable: 'NAIYO', label: '内容確認依頼', width: 150 },
  // { variable: 'DENPYO_KBN', label: '伝票区分', width: 2 }, // 伝票番号に変更 JBCC塩川@20250521
  { variable: 'DENPYO_NO', label: '伝票番号', width: 105 },
  { variable: 'GEN_TANKA', label: '原価', width: 65 },
  { variable: 'BAI_TANKA', label: '売価', width: 65 },
  { variable: 'GENKA', label: '原価金額', width: 65 },
  { variable: 'BAIKA', label: '売価金額', width: 65 },
  { variable: 'JURYO_KBN', label: '受領区分', width: 65 },
])

/**
 * 販売条件サマリテーブル
 */
export const jokenTableSummary = getWidth<{
  NO: number | string
  CHECK: number | string
  JOTAI: number | string
  JOCHO_JOTAI: number | string
  KANRI_NO: number | string
  KEN: number | string
  STRT_DT: number | string
  END_DT: number | string
  JIGYO: number | string
  ZENKOKU: number | string
  BUSHO: number | string
  TOKUI: number | string
  SIIRE: number | string
  TANTO: number | string
  ADD_TANTO: number | string
}>([
  { variable: 'NO', label: 'NO', width: 1.5 },
  { variable: 'CHECK', label: 'CHECK', width: 1 },
  { variable: 'JOTAI', label: '受領区分', width: 3 },
  { variable: 'JOCHO_JOTAI', label: '上長', width: 3 },
  { variable: 'KANRI_NO', label: '管理NO', width: 3.5 },
  { variable: 'KEN', label: '件名', width: 5 },
  { variable: 'STRT_DT', label: '期間(開始)', width: 3 },
  { variable: 'END_DT', label: '期間(終了)', width: 3 },
  { variable: 'JIGYO', label: '事業所', width: 2.5 },
  { variable: 'ZENKOKU', label: '全国', width: 2 },
  { variable: 'BUSHO', label: '課', width: 3 },
  { variable: 'TOKUI', label: '得意先名', width: 5 },
  { variable: 'SIIRE', label: '仕入先名', width: 5 },
  { variable: 'TANTO', label: '担当者', width: 3 },
  { variable: 'ADD_TANTO', label: '入力担当者', width: 3 },
])
/**
 * 販売条件明細テーブル
 */
export const jokenTableDetail = getWidth<{
  NO: number | string
  CHECK: number | string
  JOTAI: number | string
  JOCHO_JOTAI: number | string
  JAN_CD: number | string
  JP_CD: number | string
  SHOHIN_KIKAKU: number | string
  SIIRE_TAN: number | string
  NET: number | string
  MEISAI_BIKO: number | string
  HININ_RIYU: number | string
  JOCHO_HININ_RIYU: number | string
}>([
  { variable: 'NO', label: 'NO', width: 1 },
  { variable: 'CHECK', label: 'CHECK', width: 1 },
  { variable: 'JOTAI', label: '仕入先', width: 1 },
  { variable: 'JOCHO_JOTAI', label: '上長', width: 1 },
  { variable: 'JAN_CD', label: 'JANコード', width: 3 },
  { variable: 'JP_CD', label: 'JPコード', width: 1 },
  { variable: 'SHOHIN_KIKAKU', label: '品名／規格', width: 3 },
  { variable: 'SIIRE_TAN', label: '仕入単価', width: 1 },
  { variable: 'NET', label: '個人Net', width: 1 },
  { variable: 'MEISAI_BIKO', label: '明細備考', width: 4 },
  { variable: 'HININ_RIYU', label: '否認理由', width: 4 },
  { variable: 'JOCHO_HININ_RIYU', label: '上長否認理由', width: 4 },
])

/**
 * 率条件テーブル
 */
export const jokenRitsuTable = getWidth<{
  NO: number | string
  CHECK: number | string
  JOTAI: number | string
  JOCHO_JOTAI: number | string
  STRT_DT: number | string
  END_DT: number | string
  TOKUI_NM: number | string
  SIIRE_NM: number | string
  JOGAI_ITEM: number | string
  NYURYOKU: number | string
  HASU: number | string
  SEISAN_START: number | string
  CYCLE: number | string
  FIRST_SEISAN: number | string
  SEISAN_NAIYO: number | string
  CYOKU: number | string
  HENPIN: number | string
  ADD_TANTO_NM: number | string
  HININ_RIYU: number | string
  JOCHO_HININ_RIYU: number | string
}>([
  { variable: 'NO', label: 'NO', width: 1.5 },
  { variable: 'CHECK', label: 'CHECK', width: 1 },
  { variable: 'JOTAI', label: '仕入先', width: 1.5 },
  { variable: 'JOCHO_JOTAI', label: '上長', width: 2 },
  { variable: 'STRT_DT', label: '年月(開始)', width: 2 },
  { variable: 'END_DT', label: '年月(終了)', width: 2 },
  { variable: 'TOKUI_NM', label: '得意先名', width: 3 },
  { variable: 'SIIRE_NM', label: '仕入先名', width: 3 },
  { variable: 'JOGAI_ITEM', label: '除外', width: 1.5 },
  { variable: 'NYURYOKU', label: '入力率', width: 2 },
  { variable: 'HASU', label: '端数', width: 2 },
  { variable: 'SEISAN_START', label: '精算開始', width: 2 },
  { variable: 'CYCLE', label: 'サイクル', width: 2 },
  { variable: 'FIRST_SEISAN', label: '初回精算', width: 2 },
  { variable: 'SEISAN_NAIYO', label: '精算内容', width: 4 },
  { variable: 'CYOKU', label: '直', width: 1 },
  { variable: 'HENPIN', label: '返', width: 1 },
  { variable: 'ADD_TANTO_NM', label: '入力担当者名', width: 3 },
  { variable: 'HININ_RIYU', label: '否認理由', width: 8 },
  { variable: 'JOCHO_HININ_RIYU', label: '上長否認理由', width: 8 },
])

/**
 * ユーザー登録サマリテーブル
 */
export const userTableSummary = getWidth<{
  CHECK: number | string
  TOKUI_CD: number | string
  TOKUI_NM: number | string
  TEN_CD: number | string
  TEN_NM: number | string
  MAIL: number | string
  NAME: number | string
}>([
  { variable: 'CHECK', label: 'CHECK', width: 1 },
  { variable: 'TOKUI_CD', label: '得意先コード', width: 3 },
  { variable: 'TOKUI_NM', label: '得意先名', width: 5 },
  { variable: 'TEN_CD', label: '店舗コード', width: 3 },
  { variable: 'TEN_NM', label: '店舗名', width: 5 },
  { variable: 'MAIL', label: 'メールアドレス', width: 7 },
  { variable: 'NAME', label: '氏名', width: 5 },
])
/**
 * ユーザー登録明細テーブル
 */
export const userTableDetail = getWidth<{
  CHECK: number | string
  TEN_CD: number | string
  TEN_NM: number | string
  MAIL: number | string
  NAME: number | string
}>([
  { variable: 'CHECK', label: 'CHECK', width: 1 },
  { variable: 'TEN_CD', label: '店舗コード', width: 3 },
  { variable: 'TEN_NM', label: '店舗名', width: 5 },
  { variable: 'MAIL', label: 'メールアドレス', width: 7 },
  { variable: 'NAME', label: '氏名', width: 5 },
])

/**
 * 除外アイテム照会テーブル
 */
export const jogaiItemTable = getWidth<{
  JAN_CD: number | string
  JP_CD: number | string
  SHOHIN_KIKAKU: number | string
}>([
  { variable: 'JAN_CD', label: 'JANコード', width: 7 },
  { variable: 'JP_CD', label: 'JPコード', width: 4 },
  { variable: 'SHOHIN_KIKAKU', label: '品名／規格', width: 28 },
])
/**
 * ログテーブル
 */
export const logTable = getWidth<{
  ADD_YMD: number | string
  ADD_HNS: number | string
  TOROKU_KBN: number | string
  JIGYO_CD: number | string
  JIGYO_NM: number | string
  TOKUI_CD: number | string
  TOKUI_NM: number | string
  TEN_CD: number | string
  TEN_NM: number | string
  MAIL: number | string
  NAME: number | string
  ADD_MAIL: number | string
  ADD_NAME: number | string
}>([
  { variable: 'ADD_YMD', label: '日付', width: 2.2 },
  { variable: 'ADD_HNS', label: '時間', width: 1.8 },
  { variable: 'TOROKU_KBN', label: '区分', width: 1 },
  { variable: 'JIGYO_CD', label: '事業所CD', width: 1 },
  { variable: 'JIGYO_NM', label: '事業所名', width: 1 },
  { variable: 'TOKUI_CD', label: '得意先CD', width: 1 },
  { variable: 'TOKUI_NM', label: '得意先名', width: 4 },
  { variable: 'TEN_CD', label: '店舗CD', width: 1 },
  { variable: 'TEN_NM', label: '店舗名', width: 4 },
  { variable: 'MAIL', label: 'メール', width: 4 },
  { variable: 'NAME', label: '氏名', width: 2 },
  { variable: 'ADD_MAIL', label: '登録者メール', width: 4 },
  { variable: 'ADD_NAME', label: '登録者名', width: 2 },
])

/**
 * 手入力分照会サマリテーブル
 */
export const tenyuryokuTableSummary = getWidth<{
  NO: number | string
  CHECK: number | string
  JOTAI: number | string
  JOCHO_JOTAI: number | string
  DENPYO_NO: number | string
  SYORI_YMD: number | string
  SEISAN_NAIYO: number | string
  JIGYO_NM: number | string
  SIIRE_NM: number | string
  TANTO_NM: number | string
  SEISAN_TOTAL_GK: number | string
  existFile: number | string
  BIKOU: number | string
}>([
  { variable: 'NO', label: 'NO', width: 1.5 },
  { variable: 'CHECK', label: 'CHECK', width: 1 },
  { variable: 'JOTAI', label: '仕入先', width: 2 },
  { variable: 'JOCHO_JOTAI', label: '上長', width: 2 },
  { variable: 'DENPYO_NO', label: '処理NO', width: 3 },
  { variable: 'SYORI_YMD', label: '処理票日付', width: 2.5 },
  { variable: 'SEISAN_NAIYO', label: '件名', width: 6.5 },
  { variable: 'JIGYO_NM', label: '事業所', width: 2 },
  { variable: 'SIIRE_NM', label: '仕入先名', width: 3.5 },
  { variable: 'TANTO_NM', label: '担当者名', width: 2.5 },
  { variable: 'SEISAN_TOTAL_GK', label: '精算金額', width: 3.5 },
  { variable: 'existFile', label: 'ﾌｧｲﾙ', width: 1.5 },
  { variable: 'BIKOU', label: '備考', width: 3 },
])

/**
 * 手入力分照会明細テーブル
 */
export const tenyuryokuTableDetail = getWidth<{
  NO: number | string
  CHECK: number | string
  JOTAI: number | string
  JOCHO_JOTAI: number | string
  TOKUI_CD: number | string
  TOKUI_NM: number | string
  BUMON_CD: number | string
  BUMON_NM: number | string
  JAN_CD: number | string
  SHOHIN_KIKAKU: number | string
  SEISAN_SU: number | string
  SIIRE_TANKA: number | string
  KURAIRI_NET: number | string
  KOJIN_NET: number | string
  SEISAN_TANKA: number | string
  SEISAN_GK: number | string
  HININ_RIYU: number | string
  JOCHO_HININ_RIYU: number | string
}>([
  { variable: 'NO', label: 'NO', width: 1.5 },
  { variable: 'CHECK', label: 'CHECK', width: 1 },
  { variable: 'JOTAI', label: '仕入先', width: 2 },
  { variable: 'JOCHO_JOTAI', label: '上長', width: 2 },
  { variable: 'TOKUI_CD', label: '得意先CD', width: 2 },
  { variable: 'TOKUI_NM', label: '得意先名', width: 6 },
  { variable: 'BUMON_CD', label: '部門CD', width: 2 },
  { variable: 'BUMON_NM', label: '部門名', width: 3 },
  { variable: 'JAN_CD', label: 'JANｺｰﾄﾞ', width: 3.7 },
  { variable: 'SHOHIN_KIKAKU', label: '品名規格', width: 6 },
  { variable: 'SEISAN_GK', label: '合計金額', width: 2 },
  { variable: 'SEISAN_SU', label: '数量', width: 2 },
  { variable: 'SIIRE_TANKA', label: '仕入単価', width: 2 },
  { variable: 'KURAIRI_NET', label: '倉入NET', width: 2 },
  { variable: 'KOJIN_NET', label: '個人NET', width: 2 },
  { variable: 'SEISAN_TANKA', label: '単価', width: 2 },
  { variable: 'HININ_RIYU', label: '否認理由', width: 6 },
  { variable: 'JOCHO_HININ_RIYU', label: '上長否認理由', width: 6 },
])

const getColor = (alert: string) => {
  switch (alert) {
    case 'UPD':
      return '#99FFFF'
    case 'ALERT':
      return 'red'
  }
  return ''
}

export const baseStyle: React.CSSProperties = {
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  borderWidth: 1,
  borderColor: 'black',
  borderStyle: 'solid',
  padding: 3,
  maxWidth: 0,
  height: 30,
  maxHeight: 60,
}

/**
 * テーブル要素のスタイルを取得する関数
 */
export const getStyle = (width: number | string, header: boolean = false, alert: string = ''): React.CSSProperties => {
  const baseStyle = {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    borderWidth: 1,
    borderColor: 'black',
    borderStyle: 'solid',
    padding: 3,
    width: (width as number) * 100 + '%',
    height: 30,
  }
  if (header) return { ...baseStyle, backgroundColor: '#66FF99' } as React.CSSProperties
  if (alert !== '') return { ...baseStyle, maxWidth: '0', backgroundColor: getColor(alert) } as React.CSSProperties
  return { ...baseStyle, maxWidth: '0', backgroundColor: '#00FF00!important' } as React.CSSProperties
}
